/* ================ USE CUSTOMER PERMISSION HOOK ================ */
import { useMemo } from 'react';
import { PermissionsEnum } from '@am3nd-org/pointcraft-types';

import useUserDataStore from 'src/store/user';

/**
 * Hook to check if the current business has customer details permission.
 * Provides reactive state that updates when permissions change.
 *
 * @returns {Object} Object containing:
 *   - canUseCustomerDetails: boolean - Whether the permission is granted
 *
 * @example
 * ```tsx
 * import { useCustomerPermission } from 'src/online-payment/hooks';
 *
 * function MyComponent() {
 *   const { canUseCustomerDetails } = useCustomerPermission();
 *
 *   if (!canUseCustomerDetails) {
 *     return null; // or alternative UI
 *   }
 *
 *   return <CustomerDetails />;
 * }
 * ```
 */
export function useCustomerPermission() {
  const permissions = useUserDataStore(
    (state) => state.business?.configurations?.permissions ?? []
  );

  const canUseCustomerDetails = useMemo(
    () => permissions.includes(PermissionsEnum.CAN_USE_CUSTOMER_DETAILS),
    [permissions]
  );

  return { canUseCustomerDetails };
}
